activ.directive('displayGridView', function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: "./views/displayGridView.html?v=" + version,
        scope: true,
        link: function(scope, element, attrs) {

        }
    };
});